const UserProfileget = (state = [], action) => {
    switch (action.type) {
        case 'USERPROFILE_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default UserProfileget